import React, { Suspense, Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, useLocation } from 'react-router-dom';
import './App.css';

import Home from './pages/Home';

import CompanyEdit from './pages/CompanyEdit';

import Website from './pages/Website';
import WebShow from './pages/WebShow';
import WebEdit from './pages/WebEdit';

import { AuthUserContext } from './components/Session'

import Navigation from './pages/Navigation';
import Footer from './pages/Footer';
import ThankYou from './pages/ThankYou';

import { withAuthentication } from './components/Session';

// import {withFirebase} from './components/Firebase'
// const Test = (props) =>{
//   console.log(JSON.stringify(props.match.params.id))
//   const firestore = props.firebase.firestore;
//   return (<div>testPage</div>)
// } 
// class TestFire extends Component {
//   constructor(props) {
//     super(props);
//   }
//   render() {
//     return (
//         <Test {...this.props} firebase={this.props.firebase} />
//     );
//   }
// }
// const testPage = withFirebase(TestFire)




const App = (props) => (
  // let location = useLocation();
  // if(location.pathname.startsWith("/web/")){
  //   return (
      
  //   )
  // }else
    <Router>
      {/* <Route exact path="/test/:id" component={testPage}/> */}
      { window.location.href.indexOf("/web/")>-1
      ?
      <div className="c-layout-page">
        {/* <Route path="/web/:id" render={(p) => <WebShow {...props} /> } /> */}
        <Route exact path="/web/:id" component={WebShow}/>
      </div>
      :
      <div className="App">
        <Navigation />
        <div style={{marginTop:"80px"}}></div>
        <AuthUserContext.Consumer>
          { authUser => authUser && authUser.roles && !!authUser.roles["ADMIN"] && (
            <> <hr/> {JSON.stringify(authUser)} <hr/> </>
          )}
        </AuthUserContext.Consumer>
        <Route exact path="/" component={Home} />
        <Route exact path="/thankYou" component={ThankYou} />

        <Route exact path="/website" component={Website} />
        <Route exact path="/webEdit/:id" component={WebEdit} />

        <Route exact path="/company/:id" component={CompanyEdit} />
        <Footer/>
      </div>
      }
    </Router>
)

// loading component for suspense fallback
const Loader = () => (
  <div className="App">
    {/* <img src={logo} className="App-logo" alt="logo" /> */}
    <div>loading...</div>
  </div>
);

// // here app catches the suspense from page in case translations are not yet loaded
// export function LoadApp(props) {
//   return (
//     <Suspense fallback={ <Loader /> }>
//       <App {...props} />
//     </Suspense>
//   );
// }
class AAA extends React.Component {
  constructor(props) {
    super(props);
  }
  // componentDidMount () {
  //   let id = this.props.match.params;
  //   alert(JSON.stringify(id))
  // }
  render() {
    return (
      <Suspense fallback={ <Loader /> }>
        {/* <App/> */}
        <App {...this.props} firebase={this.props.firebase} />
      </Suspense>
    )
  }
}
class AppLoad extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <App {...this.props} firebase={this.props.firebase} />
    );
  }
}
export default withAuthentication(AppLoad)




